import { FC } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { PlotStatusEnum } from '@/api/rest/resources/types/plot';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useMembershipType } from '@/hooks/useMembershipType';
import { usePathSet } from '@/hooks/usePathSet';
import { usePlot } from '@/pages/shared/hooks/usePlot';
import { buildPath } from '@/utils/buildPath';
import { UnexpectedMissingDataError } from '@/utils/errors/UnexpectedMissingDataError';

import { withErrorBoundary } from '../components/ErrorBoundary';

export const RequireAccessiblePlot: FC = withErrorBoundary(() => {
  const { plotId } = useParams();
  const pathSet = usePathSet();
  const isStaffUser = useIsStaffUser();
  const membershipType = useMembershipType();

  if (!plotId) {
    throw new UnexpectedMissingDataError({ dataLabel: 'plotId' });
  }

  const plot = usePlot().data;

  if (plot.status === PlotStatusEnum.invalid) {
    const canEdit = isStaffUser || membershipType === MembershipWithOrganizationTypeEnum.land_steward;
    if (canEdit) {
      return <Navigate to={buildPath(pathSet.editPlotOrg, { pathParams: { plotId } })} replace />;
    }
    return <Navigate to={buildPath(pathSet.plots)} replace />;
  }

  return <Outlet />;
});
